export const PLACEHOLDERS: {
  [key: number]: { [key: number]: string };
} = {
  1: {
    1: "1つのことをじっくり書いてもいいし、たくさん書き出してもOK。\n（例）「サッカーが好き。試合で点を決める瞬間が最高」「本を読むのが好き。ファンタジー小説の世界観にワクワクする」",
    2: "何かに夢中になって取り組んだり、人よりちょっと得意だと思えたことを書いてみよう。\n（例）「プレゼンで褒められた経験から、人に伝えるのが得意かも」「小さい頃から絵を描くのが好きで、よく友達に頼まれていた」",
  },
  2: {
    1: "まだ決まっていなくてもOK。「なんとなく気になる」「こういうことができたら楽しそう」でも大丈夫。\n（例）「デザインに興味があるから、デザイン系の学校で学ぶのがワクワクしそう」「スポーツが好きだから、体育の先生やコーチになるのも楽しそう」「自分でゲームを作れるようになったら面白そう」",
    2: "仕事や生活、周りの環境、「こうなったらどうしよう」と思うことでもOK。\n（例）「やりたいことを見つけられるのか不安」「仕事でちゃんとやっていけるのか、生活できるのか心配」「日本が将来どうなっているのか分からなくて不安」",
  },
  3: {
    1: "身近なことでも、世界のニュースでもOK。\n（例）「AIが進化しているって聞いたけど、どんな影響があるんだろう？」「最近、食品ロスの問題をニュースで見て、もったいないなと思った」「友達と話していた『働き方の違い』が面白かった」",
    2: "自分の身近な生活のことでも、社会の大きなことでもOK。\n（例）「もっと通学しやすくなるといいのに」「みんなが好きな仕事をできる社会だったらいいのに」「新しいエネルギーがもっと広がれば、環境にいいかも？」",
  },
  4: {
    1: "これからの社会がどう変わっていくのか、自由に想像してみよう。\n（例）「宇宙旅行が当たり前になったら行ってみたい」「どんな病気も治るようになるかもしれない」「AIが発展しすぎたら、人間の仕事はどうなるんだろう？」「気候変動が進んで、自然災害がもっと増えるかもしれない」",
    2: "社会がどんなふうに変わっていくか、想像してみよう。\n（例）「SNSが増えてきてるから、リアルな友達が大事になる」「みんな長生きになって、年齢に関係なく挑戦できる環境が増えるかも」「働き方が多様になるからこそ、自分にとっての幸せを見つける力が必要になりそう」",
  },
};

export const APPLY_FOR_CAREER_MAP_GENERATION_MESSAGE = {
  title: "キャリア開拓MAPの生成を申請しますか？",
  text: "記入したデータをもとに、あなただけの\n「キャリア開拓MAP」を作成します。\n完成までに時間がかかる場合がありますが、\n完成次第、タイムラインの上部でお知らせします。",
};

export const ALERTS = {
  GENERATING_MAP:
    "現在、最新のキャリア開拓MAPを生成中です。\nしばらくお待ちください。",
  MAP_COMPLETED: "完成したキャリア開拓MAPを見てみましょう！",
  QUESTION_TRY:
    "キャリア開拓クエスチョンに答えてみましょう！\n全て答えると、新たなMAPを生成できます。",
};
